import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/artificial-intelligence-and-machine-learning-development-service.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/blockchain-development-services.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/cloud-application-development-services.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/custom-software-development-service.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/e-commerce-development-services.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/enterprise-software-development-services.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/iot-application-development-services.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/it-staff-augmentation-services.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/managed-it-services.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/mobile-app-development-services.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/web-development-services.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Webkorps-Website/src/components/pages/ServicesPage.jsx");
